import { isReadOnlyUser } from '@/mixins/user-access'

export const toolkitAlertPayload = (feature = 'this action') => ({
  alert: true,
  alertType: 'warning',
  alertMessage: `Looks like ${feature} is not a part of your toolkit—yet`,
  messages: ['Check with your admin or reach out to JBG Support at jbg.support@jbgottstein.com if you think you should have access.'],
  timeout: 3000
})

export const displayAlert = {
    data () {
      return {
        alert: false,
        alertType: 'warning',
        alertMessage: '',
        errors: [],
        messages: [],
        successes: [],
        timeout: -1
      }
    },
    watch: {
      errors: {
        handler (newValue) {
          if (newValue) {
            if (this.errors.length >= 1) {
              this.emitAlert(true, 'warning', 'Please correct the following errors: ', this.errors, this.timeout)
            }
          }
        }
      },
      successes: {
        handler (newValue) {
          if (newValue) {
            if (this.successes.length >= 1) {
              this.emitAlert(true, 'success', 'Success: ', this.successes, this.timeout)
            }
          }
        }
      }
    },
    methods: {
      emitAlert (showAlert, alertType, alertMessage, messages, timeout) {
        const payload = {
          alert: showAlert,
          alertType: alertType,
          alertMessage: alertMessage,
          messages: messages,
          timeout: timeout
        }
        this.$root.$emit('alertdialog', payload)
      },
      resetAlert () {
        this.errors.length = 0
        this.successes.length = 0
        const payload = {
          alert: false,
          alertType: 'success',
          alertMessage: '',
          messages: []
        }
        this.$root.$emit('alertdialog', payload)
      },
      handleRejected (rejected) {
        const errs = rejected.map(e => e.reason?.response?.data?.message || e.reason.message)
        this.emitAlert(true, 'warning', `The following errors have occurred: ${errs.join(', ')}`)
      },
      handleError (err) {
        if (Array.isArray(err)) {
          return this.handleRejected(err)
        }
        console.error(err)
        if (err?.response?.status === 403 && isReadOnlyUser(this.$auth)) {
          const { alertType, alertMessage, messages, timeout } = toolkitAlertPayload()
          return this.emitAlert(true, alertType, alertMessage, messages, timeout)
        }
        const message = err?.response?.data?.message || err.message
        this.emitAlert(true, 'warning', message)
      }
    }
  }
  